import React from 'react';
import { Row, Col, Input, FormGroup } from 'reactstrap';
import { delegations } from 'services';

import CollapsibleCard from './CollapsibleCard';
import { InputType } from 'reactstrap/types/lib/Input';

interface Options {
  [key: string]: any
}

export interface Field {
  name: string
  field: string
  type?: InputType
  selectOptions?: Options
  defaultKey?: string
  colSize?: number
}

interface Props {
  onFilter: (filter: { key: string, value: any }) => void
  fields: Field[]
  open?: boolean
}


function Filters(props: Props) {
  const { onFilter, fields, open = false } = props;

  const getSelectByField = (field: string) => {
    if (field === 'delegation') {
      return (
        Object
          .entries(delegations)
          .map(([key, value]) => (
            <option key={key} value={key}>{value}</option>),
          )
      );
    }
    const index = fields.findIndex(i => i.field === field);
    if (index !== -1) {
      if (!fields[index].selectOptions) return null;

      return (
        Object
          .entries(fields[index].selectOptions ?? [])
          .map(([key, value]) => (
            <option key={key} value={key}>{ value }</option>),
          )
      );
    }
    return null;
  };

  const setFilters = () => {
    return fields.map(({ name, field, type, defaultKey, colSize }) => (
      <Col key={field} md={colSize || 4}>
        <FormGroup>
          <label>{name}</label>
          <Input
            style={ type === 'select' ? { height: 'calc(2.75rem + 2px)' } : undefined }
            type={type}
            defaultValue={type === 'select' ? defaultKey || 'any' : ''}
            onChange={e => filter(field, e.target.value) }
          >
            {type === 'select' ? <>
              <option key='any' value='any'>Todas</option>
              {
                getSelectByField(field)
              }
            </> : null}
          </Input>
        </FormGroup>
      </Col>
    ));
  };

  const filter = (key: string, value: any) => {
    if (onFilter) {
      return onFilter({ key, value });
    }
  };

  return (
    <>
      <CollapsibleCard title='Filtros' className='shadow mb-3' open={open}>
        <Row className={`table-filters`}>
          { setFilters() }
        </Row>
      </CollapsibleCard>
    </>
  );
}

export default Filters;
